module.exports = __webpack_public_path__ + "img/reduced_size_gif2.299aba3d.gif";